<template>
	<div class="component upvote" :class="{ 'upvote--navbar': navBarItem }">
		<div class="votes">
			<div class="vote-control up-vote" v-show="showUpVote">
				<button
					type="button"
					class="vote-button"
					:class="{ active: currentUserVote == 1, pulse: pulseUp }"
					:aria-label="'Omhoog stemmen (' + totalUpVotes + ')'"
					@click="upVote(elementId, voteKey)"
				>
					<CircleArrowUp :size="18" :stroke-width="2" />
					<span v-show="!hideTotalUp && showUpVote" class="total-up-votes">{{ totalUpVotes }}</span>
				</button>
			</div>

			<div class="tally-vote" v-show="showTallyVote">{{ totalTallyVotes }}</div>

			<div class="vote-control down-vote" v-show="showDownVote">
				<button
					type="button"
					class="vote-button"
					:class="{ active: currentUserVote == -1, pulse: pulseDown }"
					:aria-label="'Omlaag stemmen (' + totalDownVotes + ')'"
					@click="downVote(elementId, voteKey)"
				>
					<CircleArrowDown :size="18" :stroke-width="2" />
					<span v-show="!hideTotalDown && showDownVote" class="total-down-votes">{{ totalDownVotes }}</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import CircleArrowDown from "@lucide/vue/dist/esm/icons/circle-arrow-down.mjs";
import CircleArrowUp from "@lucide/vue/dist/esm/icons/circle-arrow-up.mjs";

export default {
	name: "upvote",
	components: {
		CircleArrowDown,
		CircleArrowUp,
	},
	props: {
		elementId: {
			type: Number,
			required: true,
		},
		voteKey: {
			type: String,
			default: null,
		},
		upVotes: {
			type: Number,
			default: null,
		},
		downVotes: {
			type: Number,
			default: null,
		},
		tallyVotes: {
			type: Number,
			default: null,
		},
		currentVote: {
			type: Number,
			default: null,
		},
		showUpVote: {
			type: Boolean,
			default: true,
		},
		showDownVote: {
			type: Boolean,
			default: true,
		},
		showTallyVote: {
			type: Boolean,
			default: true,
		},
		hideTotalUp: {
			type: Boolean,
			default: false,
		},
		hideTotalDown: {
			type: Boolean,
			default: false,
		},
		navBarItem: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			totalUpVotes: 0,
			totalDownVotes: 0,
			totalTallyVotes: 0,
			hasVoted: false,
			currentUserVote: undefined,
			pulseUp: false,
			pulseDown: false,
		};
	},
	computed: {
		downVotesTooltip() {
			return "Downvotes: " + this.totalDownVotes;
		},
		requireLogin() {
			return true;
		},
		isApp() {
			return this.$root.device.app;
		},
	},
	mounted() {
		var component = this;

		if (component.upVotes) {
			component.totalUpVotes = component.upVotes;
		}
		if (component.downVotes) {
			component.totalDownVotes = component.downVotes;
		}
		if (component.tallyVotes) {
			component.totalTallyVotes = component.tallyVotes;
		}
		if (component.currentVote) {
			component.currentUserVote = component.currentVote;
			component.hasVoted = true;
		}

		this.$logger(
			"app/components/upvote/mounted, elementId: " + component.elementId,
		);
	},
	methods: {
		upVote(elementId, voteKey) {
			this.$logger("app/components/upvote/upVote");
			var component = this;
			var app = this.$root;

			if (!elementId) {
				return;
			}

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			component.vote(elementId, voteKey, "upvote");
		},
		downVote(elementId, voteKey) {
			this.$logger("app/components/upvote/downVote");

			var app = this.$root;
			var component = this;

			if (!elementId) {
				return;
			}

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			component.vote(elementId, voteKey, "downvote");
		},
		vote(elementId, voteKey, type) {
			this.$logger("app/components/upvote/vote");

			var component = this;
			var app = this.$root;

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			if (
				component.hasVoted &&
				((type == "downvote" && component.currentUserVote == -1) ||
					(type == "upvote" && component.currentUserVote == 1))
			) {
				this.$logger("app/components/upvote/vote/already-voted");

				UIkit.notification({
					message: "Je hebt al gestemd!",
					status: "error",
					pos: "bottom-right",
					timeout: 3000,
				});

				return;
			}

			// Check for cookie
			var currentVotes = [];
			var vote = type == "upvote" ? 1 : -1;

			try {
				//currentVotes = JSON.parse(_helper.cookie.get("currentVotes"));
			} catch (e) {}

			if (currentVotes.length) {
				var elementExists = false;
				var voteExists = false;

				for (var i = 0; i < currentVotes.length; i++) {
					if (currentVotes[i].elementId == elementId) {
						elementExists = true;

						// Swap vote if it exists
						if (currentVotes[i].vote != vote) {
							currentVotes[i].vote = vote;
						} else {
							voteExists = true;
						}

						break;
					}
				}

				// Add new vote
				if (!elementExists && !voteExists) {
					currentVotes.push({
						elementId: elementId,
						vote: vote,
					});
				} else if (elementExists && !voteExists) {
					this.$logger("app/components/upvote/swap-vote/" + vote);
				} else {
					UIkit.notification({
						message:
							'<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/></svg> Je hebt al gestemd',
						status: "error",
						pos: "bottom-right",
						timeout: 2000,
					});

					this.$logger("app/components/upvote/already-voted");
					return;
				}
			} else {
				currentVotes.push({
					elementId: elementId,
					vote: vote,
				});
			}

			// Reset pulse class
			component.pulseUp = false;
			component.pulseDown = false;

			//component.updateVoteTotals();

			// Set data
			var data = {
				id: elementId,
				key: voteKey,
			};

			// Append CSRF Token
			data[window.csrfTokenName] = window.csrfTokenValue;

			// Determine action url; should we swap votes or cast a new vote?
			var actionUrl = "/actions/upvote/vote/" + type;

			if (component.hasVoted) {
				actionUrl = "/actions/upvote/vote/swap";
			}

			// Request
			axios({
				method: "post",
				url: actionUrl,
				responseType: "json",
				data: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json",
				},
			})
			.then(function (response) {
				component.$logger(response);

				// Success
				var data = response.data;

				// Already voted
				if (data == "You have already voted on this element.") {
					UIkit.notification({
						message:
							'<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/></svg> Je hebt al gestemd',
						status: "error",
						pos: "bottom-right",
						timeout: 3000,
					});

					// Voted
				} else {
					component.$logger(
						"app/components/upvote/vote/success: " + data.vote,
					);
					component.hasVoted = true;
					component.updateVoteTotals(data);
				}
			})
			.catch(function (error) {
				if (error) {
					console.error(error);
				}
			});
		},
		updateVoteTotals(data) {
			var component = this;

			component.$logger("app/components/upvote/vote/updateVoteTotals");

			component.currentUserVote = data.userVote;
			component.totalUpVotes = data.totalUpvotes;
			component.totalDownVotes = data.totalDownvotes;
			component.totalTallyvotes = data.tally;

			if (component.currentUserVote == 1) {
				component.pulseUp = true;
			} else {
				component.pulseDown = true;
			}
		},
	},
};
</script>

<style scoped>
.component.upvote {
	display: inline-flex;
}
.votes,
.vote-control {
	display: flex;
	align-items: center;
}
.votes {
	gap: 9px;
}
.vote-control {
	gap: 0;
}
.vote-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: auto;
	min-width: 36px;
	height: 36px;
	gap: 5px;
	padding: 0 8px;
	border: 1px solid #e1e4e8;
	border-radius: 7px;
	background: #f5f6f7;
	color: #686e76;
	cursor: pointer;
	transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.vote-button svg {
	width: 18px;
	height: 18px;
	fill: none;
}
.vote-button:hover,
.vote-button:focus-visible,
.vote-button.active {
	border-color: rgba(255, 61, 0, 0.28);
	background: rgba(255, 61, 0, 0.08);
	color: var(--tint-color);
	outline: none;
}
.component.upvote .total-up-votes,
.component.upvote .total-down-votes {
	min-width: 1ch;
	padding: 0;
	color: inherit;
	font-size: 0.82rem;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	line-height: 1;
}
.tally-vote {
	color: #686e76;
	font-size: 0.88rem;
}
:global(body.dark .vote-button) {
	border-color: #343943;
	background: #242830;
	color: #b3b9c2;
}
:global(body.dark .component.upvote .vote-button svg) {
	fill: none;
}
:global(body.dark .vote-button:hover),
:global(body.dark .vote-button:focus-visible),
:global(body.dark .vote-button.active) {
	border-color: rgba(255, 61, 0, 0.38);
	background: rgba(255, 61, 0, 0.12);
	color: #ff6333;
}
:global(body.dark .tally-vote) {
	color: #b3b9c2;
}
</style>
